import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { isObject } from "tsparticles-engine";
export var CircleDrawer = /*#__PURE__*/function () {
  function CircleDrawer() {
    _classCallCheck(this, CircleDrawer);
  }

  _createClass(CircleDrawer, [{
    key: "draw",
    value: function draw(context, particle, radius) {
      if (!particle.circleRange) {
        particle.circleRange = {
          min: 0,
          max: Math.PI * 2
        };
      }

      var circleRange = particle.circleRange;
      context.arc(0, 0, radius, circleRange.min, circleRange.max, false);
    }
  }, {
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "particleInit",
    value: function particleInit(container, particle) {
      var _shapeData$angle;

      var shapeData = particle.shapeData,
          angle = (_shapeData$angle = shapeData === null || shapeData === void 0 ? void 0 : shapeData.angle) !== null && _shapeData$angle !== void 0 ? _shapeData$angle : {
        max: 360,
        min: 0
      };
      particle.circleRange = !isObject(angle) ? {
        min: 0,
        max: angle * Math.PI / 180
      } : {
        min: angle.min * Math.PI / 180,
        max: angle.max * Math.PI / 180
      };
    }
  }]);

  return CircleDrawer;
}();